import _ from 'lodash';

import { StartingMaterialDatasetItem } from '@f/services/starting-material/starting-material.types';

import { DatasetInputItem } from '../components/DatasetInput';
import { DatasetsById } from '../SearchParameterForm';

import { SelectedDatasetMap } from './buildDatasetMap';

export function buildDatasetInputItems(
  datasetsById: DatasetsById,
  selectedDatasetMap: SelectedDatasetMap
): DatasetInputItem[] {
  return (Object.values(datasetsById) as StartingMaterialDatasetItem[]).map(dataset => {
    const { extendedId, suppliers } = dataset;
    const selectedDataset = selectedDatasetMap[extendedId];

    if (!suppliers) {
      return {
        ...dataset,
        value: Boolean(selectedDataset),
      };
    }

    let value: string[] = [];
    if (selectedDataset) {
      value = selectedDataset?.selected_suppliers ?? Object.keys(suppliers);
    }

    return {
      ...dataset,
      supplierItems: _.chain(suppliers)
        .toPairs()
        .sortBy('1')
        .map(([id, name]) => ({
          id,
          name,
        }))
        .value(),
      value,
    };
  });
}
